import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Const, ResourceState, ResourceType } from '../../../../core/helpers/Const';
import { ActivatedRoute } from '@angular/router';
import { HeaderTitleService } from '../../../../service/services/misc/header-title/header-title.service';
import { NavigationService } from '../../../../service/services/misc/navigation/navigation.service';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { ResourcePageComponent } from '../../../../core/components/abstract/resource-page/resource-page.component';
import { Utils } from '../../../../core/helpers/Utils';
import { DialogService } from '../../../../service/services/misc/dialog/dialog.service';
import { OrganizationHierarchyStoreService } from '../../../../service/store/organization-hierarchy-store/organization-hierarchy-store.service';
import { ResourceDataService } from '../../../../service/services/rest/resource-data/resource-data.service';
import {TablePersonalizationDefinitions} from '../../../../core/helpers/TablePersonalizationDefinitions';
import {EventService} from "../../../../service/services/misc/event/event.service";
import {UisService} from "../../../../service/services/misc/uis/uis.service";
import {SwaService} from "../../../../service/services/misc/swa/swa.service";
import {ResourceNotificationService} from "../../../../service/services/misc/fcl/resource-notification.service";
import {SavedFilterViewsService} from "../../../../service/services/misc/saved-filter-views/saved-filter-views.service";


@Component({
    selector: 'app-resourcegroup',
    templateUrl: './resourcegroup.component.html',
    styleUrls: ['./resourcegroup.component.scss'],
    standalone: false
})
export class ResourcegroupComponent extends ResourcePageComponent implements OnInit {
    ResourceType = ResourceType;
    Utils = Utils;
    Const = Const;
    ResourceState = ResourceState;
    items: ResourceModel[];
    Object = Object;
    override availableResourceTypes: any[] = [];

    get currentTableKey(): string {
        return this.advancedSearchOpen
            ? TablePersonalizationDefinitions.AdvancedSearchTable.key
            : TablePersonalizationDefinitions.ResourcesTable.key;
    }

    constructor(
		protected override _navigationService: NavigationService,
		private _route: ActivatedRoute,
		protected override _headerTitleService: HeaderTitleService,
		private dialogService: DialogService,
		private organizationHierarchyStore: OrganizationHierarchyStoreService,
		private resourceDataService: ResourceDataService,

      protected override cdRef: ChangeDetectorRef,
      protected override eventService: EventService,
        protected override uisService: UisService,
        protected override swaService: SwaService,
        protected override resourceNotificationService: ResourceNotificationService,
        savedFilterViewsService: SavedFilterViewsService
    ) {
        super(organizationHierarchyStore, _navigationService, dialogService, _headerTitleService, resourceDataService, cdRef, eventService, uisService, swaService, resourceNotificationService, savedFilterViewsService);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.noDataMessage =
			"There are no resources in this resource group, or you don't have permissions to access the content of this resource group.";
        this.noDataFilteredMessage = 'No resources match your search query.';
        this.subscriptions.push(
            this._route.queryParams.subscribe((params) => {
                this.currentOrg = this._route.snapshot.paramMap.get('orgName');
                this.loadPage(params);
            })
        );
    }

    async loadPage(params: any) {
        this._currentPath = params['path'] || '';
        this.resourceType = ResourceType.RESOURCE_GROUP;
        this._fullPath = `${this.currentOrg}${this._currentPath || ''}`;

        this.setParentPath(this._fullPath);

        // Close advanced search when navigating to a different location
        // This ensures the path column is removed if it was added by advanced search
        if (this.advancedSearchOpen) {
            this.advancedSearchOpen = false;
        }

        this.currentResource = this._currentPath.split('/')[this._currentPath.split('/').length - 1];
        await this.setResourceTitles();
        await this.loadServices();
        if (Utils.hasFeatureFlag(Const.FEATURE_ADVANCED_SEARCH)) {
            await this.loadDiscoveryApiResources();
        }
    }
}
